import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import { useAppSelector } from 'hooks/reduxHooks'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'

const image: App.Image = {
  id: 'kf3r6fahlubu2yb1htkgb',
  title: 'Faster, priority support',
}

interface Props {
  tier: App.LoyaltyTier
}

function LandingPageLoyaltyPhoneSupport(props: Props) {
  const { tier } = props
  const geoContact = useAppSelector(state => state.geo.currentContact)

  return <LandingPageLoyaltyBenefitTile
    heading="Faster, priority support"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>All year round</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" href={`tel:${geoContact.local.number}`} startIcon={<LinePhoneIcon />}>
      {geoContact.local.humanReadable}
    </TextButton>}
  >
    <BodyText variant="medium">
      Skip the queue. Our dedicated support team is just a call away, any time of day or night, with faster response times and help when you need it most.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyPhoneSupport
